import script from "./AppShell.vue?vue&type=script&setup=true&lang=js"
export * from "./AppShell.vue?vue&type=script&setup=true&lang=js"

import "./AppShell.vue?vue&type=style&index=0&id=af9606d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af9606d8"]])

export default __exports__